import { render, staticRenderFns } from "./CustPopup.vue?vue&type=template&id=008fbeee&scoped=true&"
import script from "./CustPopup.vue?vue&type=script&lang=js&"
export * from "./CustPopup.vue?vue&type=script&lang=js&"
import style0 from "./CustPopup.vue?vue&type=style&index=0&id=008fbeee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008fbeee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
